import { NAMESPACE } from 'react/api/actions/base';

export const actions = {
  toggleOrganizationFieldsModal: `${NAMESPACE}_SAML_WIZARD_TOGGLE_ORGANIZATION_FIELDS_MODAL`,
  openOrganizationFieldsModal: `${NAMESPACE}_SAML_WIZARD_OPEN_ORGANIZATION_FIELDS_MODAL`,
  toggleLocaleKeyFieldsModal: `${NAMESPACE}_SAML_WIZARD_TOGGLE_LOCALE_KEY_FIELDS_MODAL`,
  openLocaleKeyFieldsModal: `${NAMESPACE}_SAML_WIZARD_OPEN_LOCALE_KEY_FIELDS_MODAL`,
  toggleGroupsFieldsModal: `${NAMESPACE}_SAML_WIZARD_TOGGLE_GROUPS_FIELDS_MODAL`,
  openGroupsFieldsModal: `${NAMESPACE}_SAML_WIZARD_OPEN_GROUPS_FIELDS_MODAL`,
  toggleUserTagFieldsModal: `${NAMESPACE}_SAML_WIZARD_TOGGLE_USER_TAG_FIELDS_MODAL`,
  openUserTagFieldsModal: `${NAMESPACE}_SAML_WIZARD_OPEN_USER_TAG_FIELDS_MODAL`,
  initializeIdpUrlValidation: `${NAMESPACE}_SAML_WIZARD_INITIALIZE_IDP_URL_VALIDATION`,
  stopIdpUrlValidation: `${NAMESPACE}_SAML_WIZARD_STOP_IDP_URL_VALIDATION`,
  confirmIdpUrlValidation: `${NAMESPACE}_SAML_WIZARD_CONFIRM_IDP_URL_VALIDATION`,
  denyIdpUrlValidation: `${NAMESPACE}_SAML_WIZARD_DENY_IDP_URL_VALIDATION`,
  saveForm: `${NAMESPACE}_SAML_WIZARD_SAVE_FORM`,
  fetchInitialFormValues: `${NAMESPACE}_SAML_WIZARD_FETCH_INITIAL_FORM_VALUES`,
  clearCertificate: `${NAMESPACE}_SAML_WIZARD_CLEAR_CERTIFICATE`
};

export const actionCreators = {
  toggleOrganizationFieldsModal: (payload) => ({ type: actions.toggleOrganizationFieldsModal, payload }),
  openOrganizationFieldsModal: (payload) => ({ type: actions.openOrganizationFieldsModal, payload }),
  toggleLocaleKeyFieldsModal: (payload) => ({ type: actions.toggleLocaleKeyFieldsModal, payload }),
  openLocaleKeyFieldsModal: (payload) => ({ type: actions.openLocaleKeyFieldsModal, payload }),
  toggleGroupsFieldsModal: (payload) => ({ type: actions.toggleGroupsFieldsModal, payload }),
  openGroupsFieldsModal: (payload) => ({ type: actions.openGroupsFieldsModal, payload }),
  toggleUserTagFieldsModal: (payload) => ({ type: actions.toggleUserTagFieldsModal, payload }),
  openUserTagFieldsModal: (payload) => ({ type: actions.openUserTagFieldsModal, payload }),
  initializeIdpUrlValidation: (payload) => ({ type: actions.initializeIdpUrlValidation, payload }),
  stopIdpUrlValidation: (payload) => ({ type: actions.stopIdpUrlValidation, payload }),
  confirmIdpUrlValidation: (payload) => ({ type: actions.confirmIdpUrlValidation, payload }),
  denyIdpUrlValidation: (payload) => ({ type: actions.denyIdpUrlValidation, payload }),
  saveForm: (payload) => ({ type: actions.saveForm, payload }),
  fetchInitialFormValues: (payload) => ({ type: actions.fetchInitialFormValues, payload }),
  clearCertificate: (payload) => ({ type: actions.clearCertificate, payload })
};

export default {
  actions,
  actionCreators
};
